import React from 'react'
import classNames from 'classnames'

const checkedHandle = (next, e) => next(e.target.checked)

export default ({ checked, isLight, onChange, disabled = false }) => (
  <div className={classNames('Checkbox', {
    'Checkbox_light': isLight,
    'Checkbox_checked': checked
  })}>
    <label className='Checkbox__label'>
      <input type='checkbox' className='Checkbox__field' onChange={disabled ? undefined : checkedHandle.bind(this, onChange)} />
      <span className='Checkbox__control' />
    </label>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Checkbox.jsx